import React, { useEffect, useState } from "react";
import { Button } from "@mui/material";
import { KeyboardArrowUp } from "@mui/icons-material";
import { observer } from "mobx-react-lite";


export default observer(function BackToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 600);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) {
    return null;
  }

  return (
    <Button
      variant="contained"
      onClick={scrollToTop}
      sx={{
        position: "fixed",
        right: 40,
        bottom: 40,
        zIndex: 1000,
        borderRadius: "50%",
        minWidth: "0",
        width: 56,
        height: 56,
      }}
    >
      <KeyboardArrowUp />
    </Button>
  );
});
